import { SingleCardProps } from './feature-guide-cards.types';
import { useDyfFdsCardContent } from '../../../../../views/dyf-landing-view/hooks/use-dyf-fds-cards';
import { useDyfFdsButtonContent } from '../../../../../views/dyf-landing-view/hooks/use-dyf-fds-buttons';
import { FMCardProps } from '@own/fds-react/dist/types/fm-card.types';
import { generateFMCardProps } from '.';
import { useMemo } from 'react';

export const useLivestreamCard = (props: SingleCardProps): FMCardProps => {
    const { onClickAnalytics, href, modelDisplayName } = props;

    const dyfLandingLivestreamCard = useDyfFdsCardContent('livestream');
    const dyfLandingLivestreamCardButton = useDyfFdsButtonContent('livestream');

    const cardData = useMemo(
        () =>
            generateFMCardProps(
                dyfLandingLivestreamCard,
                dyfLandingLivestreamCardButton,
                href,
                '',
                onClickAnalytics,
                modelDisplayName
            ),
        [
            href,
            '',
            onClickAnalytics,
            modelDisplayName,
            dyfLandingLivestreamCard,
            dyfLandingLivestreamCardButton,
        ]
    );

    return cardData;
};
